import * as React from "react";
import { forwardRef } from "react";
const SvgRemoveIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.75 12.25L12.25 1.75", stroke: "#08B6AB", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.25 12.25L1.75 1.75", stroke: "#08B6AB", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgRemoveIcon);
export { ForwardRef as ReactComponent };
